/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import CallMadeIcon from '@material-ui/icons/CallMade';
import NoDataError from './NoDataError';

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    backgroundColor: '#fff',
    borderRadius: '6px',
    padding: '2rem 1rem 1rem 1rem',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    margin: '20px auto',
    width: '601px',
    height: '646px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '90vw !important',
    },
    [theme.breakpoints.up('sm')]: {
      width: '79vw !important',
    },
    [theme.breakpoints.up('md')]: {
      width: '39vw !important',
    },
  },
  cardContent: {
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '200px',
    maxHeight: '404px',
    [theme.breakpoints.down('sm')]: {
      maxHeight: '400px !important',
    },
    color: 'black', 
    textAlign: 'left' ,
    overflow: 'scroll',
    overflowX: 'hidden',
    marginBottom: '1rem',
    marginTop: '6px',
  },
  listItem:{
    margin: '0px auto',
    width: '60%',
    marginBottom: '6px', 
    borderRadius: '6px', 
    padding: '10px', 
    backgroundColor: '#F5E2DC' , 
    color: '#B3261D', 
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  actionButtons: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    marginTop: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    padding: 20,
  },

  actionButtonContainer:{
    display: 'flex', 
    marginTop: '2rem',
  },
  shuffleButton: {
    margin: '0px auto !important',
    backgroundColor: '#B3261D !important',
    color: 'white !important ',
    borderColor: 'transparent !important',
    textTransform: 'uppercase',
    width: '89% !important',
    borderRadius: '6px',
    marginTop: '2rem',
    height: '52px',
    '& span':{
      fontFamily: 'Raleway, sans-serif !important',
      fontSize: '14px',
      fontWeight: '700',
      lineHeight: '28px',
      letterSpacing: '1px',
      '& svg':{
        fontSize: '1.1rem',
        marginLeft: '0.2rem'
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
      }, 
    },
    
  },
  trackIdx: {
    fontFamily: 'Raleway, Mono, sans-serif !important',
    fontSize: '14px !important',
    fontWeight: '500',
    lineHeight: '28px',
    letterSpacing: '0px',
  },
  playlistName: {
    fontFamily: 'Raleway, sans-serif !important',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '18px',
    letterSpacing: '0px',
  },
  ownerName: {
    fontFamily: 'Raleway, sans-serif !important',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '18px',
    letterSpacing: '0px',
    opacity: '0.8'
  },
  trackImageContainer:{
    display: 'flex', justifyContent: 'center', alignItems:'center'
  },
  trackPlusArtistContainer: {
  display:'flex', 
  flexDirection: 'column', 
  width: '100px',
  // [theme.breakpoints.down('sm')]: {
  //   width: '100px',
  // }, 

},
  trackItemIcon: {
    fontSize: '1.2rem'
  },
  // trackItemActionContainer:{
  //   textDecoration: 'none',
  //   color: '#B3261D',
  //   cursor: 'pointer'
  // }
}));

const getTrimmedName = (name, maxLength) => {
    if (name.length >=maxLength) {
      const trimmedName = name.slice(0, maxLength - 3) + '...';
      return trimmedName;
    }
    return name;
  }

// const getPlaylistDuration = (tracks) => {
//   const totalDurationInMilliseconds = tracks?.reduce((acc, track) => acc + track.duration_ms, 0);
//   if(totalDurationInMilliseconds){
//     const totalHours = Math.floor(totalDurationInMilliseconds / (60 * 60 * 1000));
//     const totalMinutes = Math.floor((totalDurationInMilliseconds % (60 * 60 * 1000)) / (60 * 1000));  
//     return `${totalHours}hr ${totalMinutes}min`
//   }
//   return '';
//   }

export default function SpotifyList({ items, cardHeader, cardSubHeader, actionLabels, isMobile }) {
  const classes = useStyles();

  if (!items || items.tracks?.length === 0 || items.error) {
    return (<NoDataError />)
  } 

  // cardSubHeader = `${items?.seeds[0]?.id} / ${getPlaylistDuration(items?.tracks)}`;

  const redirectToSpotify = () => {
    if (isMobile) {
      window.location.href = 'spotify://open';
      setTimeout(() => {
        if (!document.hidden) {
          const appStoreLink = 'https://apps.apple.com/us/app/spotify-music/id324684580'; 
          const playStoreLink = 'https://play.google.com/store/apps/details?id=com.spotify.music';
          const storeLink = isMobile && /iPhone|iPad|iPod/i.test(navigator.userAgent) ? appStoreLink : playStoreLink;
          window.location.href = storeLink;
        }
      }, 2000);
    } else {
      window.open('https://open.spotify.com/', '_blank');
    }
  };
  const redirectToTrackItem = (externalTrackLink) => {
    if(externalTrackLink) window.open(externalTrackLink, '_blank');
    };
  const renderTrackItem = (item, idx) => {
    const playlistName = item?.name || '';
    const ownerName = item?.owner?.display_name || '';
    const externalTrackLink = item?.external_urls?.spotify || '';
    const trackImageUrl =item?.images?.[0]?.url || '';
    return (
        <div key={idx} className={classes.listItem} onClick={()=>redirectToTrackItem(externalTrackLink)}>
          <div className={classes.trackIdx}>{idx + 1}</div>
          <div className={classes.trackImageContainer}>
            <img src={trackImageUrl} width={30} alt='playlistName' />
          </div>
          <div className={classes.trackPlusArtistContainer}>
            <div className={classes.playlistName}>{getTrimmedName(playlistName, 14)}</div>
            <div className={classes.ownerName}>By {getTrimmedName(ownerName, 14)}</div>
          </div>
        </div>
    );
  };
  
  return (
    <div className={classes.cardContainer}>
      {cardHeader && <div className='cardHeader'>{cardHeader}</div>}
      {cardSubHeader && <div className='cardSubHeader' style={{textTransform:'capitalize'}}>{cardSubHeader}</div>}
      <div className={classes.cardContent}>
        {items?.map((item, idx) => renderTrackItem(item, idx))}
      </div>
      <div className={classes.actionButtonContainer}>  
      <Button className={classes.shuffleButton} onClick={redirectToSpotify}>
        {actionLabels[0]} <CallMadeIcon/>
      </Button>
      </div>
      
    </div>
  );
}
